//main-product-flavor.js
window.initAlternateSection = function() {
  window.PDPPurchaseState = window.PDPPurchaseState || {
    mode: "one",
    planId: ""
  };
  const purchaseState = window.PDPPurchaseState;

  const inventoryProduct = document.querySelector('product-info').dataset.inventory;
  const baseProductAvail = document.querySelector('product-info').dataset.available;
  const tagsProduct = document.querySelector('product-info').dataset.tags;
    const titleProduct = document.querySelector('product-info').dataset.product;
  window.ProductMeta = {
    policy: baseProductAvail,
    inventory: inventoryProduct,
    tags: tagsProduct,
    title: titleProduct
  };
 console.log(window.ProductMeta);
    // 1) Disable “+” in cart drawer when total would exceed 4
      async function disableCartDrawerPlusButtons() {
        const res       = await fetch('/cart.js');
        const cart      = await res.json();
        const totalQty  = cart.items.reduce((sum, i) => sum + i.quantity, 0);
        document.querySelectorAll('cart-drawer quantity-input').forEach(qtyInput => {
          const plusBtn    = qtyInput.querySelector('button[name="plus"]');
          const input      = qtyInput.querySelector('input[name="updates[]"]');
          const key        = input?.dataset.cartItemKey;
          const thisItem   = cart.items.find(i => i.key === key);
          const thisQty    = thisItem?.quantity || 0;
          const otherQty   = totalQty - thisQty;
          if (otherQty + thisQty + 1 > 4) {
            plusBtn.disabled = true;
            plusBtn.classList.add('disabled');
          } else {
            plusBtn.disabled = false;
            plusBtn.classList.remove('disabled');
          }
        });
      }

      // 2) Refresh cart drawer contents
      async function refreshCartDrawer() {
        const response = await fetch('/?sections=cart-drawer,header');
        const data     = await response.json();
        const drawer   = document.querySelector('cart-drawer');
        if (!drawer || !data['cart-drawer']) return;

        const docNew   = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        const newItems = docNew.querySelector('#CartDrawer-CartItems');
        const oldItems = drawer.querySelector('#CartDrawer-CartItems');
        if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;

        drawer.classList.remove('is-empty');
        drawer.querySelector('.drawer__inner-empty')?.remove();
        drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
        drawer.querySelector('#CartDrawer-Checkout')?.removeAttribute('disabled');

        const itemsSection = drawer.querySelector('.cart-items');
        if (itemsSection) {
          itemsSection.removeAttribute('hidden');
          itemsSection.setAttribute('aria-hidden', 'false');
        }

        const newTotal = docNew.querySelector('.totals__total-value');
        const oldTotal = drawer.querySelector('.totals__total-value');
        if (newTotal && oldTotal) oldTotal.innerHTML = newTotal.innerHTML;

        drawer.open();
        disableCartDrawerPlusButtons();
         enforceCartLimitOnPDP();
      }

      // 3) Refresh header cart count bubble
      async function refreshCartCount(cartCountBubble) {
        if (!cartCountBubble) return;
        const response = await fetch('/?sections=header');
        const data     = await response.json();
        const headerDoc = new DOMParser().parseFromString(data.header, 'text/html');
        const newCount  = headerDoc.querySelector('.cart-count-bubble');
        if (newCount) cartCountBubble.innerHTML = newCount.innerHTML;
      }

      // 4) Show the 4-item limit modal
      function showCartLimitModal() {
        const modal = document.getElementById('cart-limit-modal');
        if (!modal) return;
        modal.classList.remove('hidden');
        document.getElementById('cart-limit-close')?.addEventListener('click', () => {
          modal.classList.add('hidden');
        });
      }
      async function enforceCartLimitOnPDP() {
        try {
          const res      = await fetch('/cart.js');
          const cart     = await res.json();
          const totalQty = cart.items.reduce((sum, i) => sum + i.quantity, 0);
          const form     = document.querySelector("product-form form[action='/cart/add']");
          const atcBtn   = form?.querySelector('[type="submit"]');
          if (!atcBtn) return;
          const isAvailable = document.querySelector('product-info').dataset.available === 'true';
          if (!isAvailable) return;
          // Don't re-enable if MasterOOS tag is present
          const MasterOOS = window.ProductMeta?.tags?.includes("MasterOOS");
          if (MasterOOS) return;
          if (totalQty >= 4) {
            atcBtn.disabled = true;
            atcBtn.classList.add('disabled');
            showCartLimitModal();
          } else {
            atcBtn.disabled = false;
            atcBtn.classList.remove('disabled');
          }
        } catch (e) {
          console.warn('Could not enforce PDP cart limit', e);
        }
        
      }
      // 5) Custom Add to Cart that respects the 4-item limit
        async function handleAddToCart(form) {
        const btn                  = form.querySelector('[type="submit"]');
        // grab the whole HTML so we preserve the price container + spinner
        const originalButtonHTML   = btn.innerHTML;
        const variantInput         = form.querySelector("input[name='id']");
        const sellingPlanInput     = form.querySelector("input[name='selling_plan']");
        const cartCountBubble      = document.querySelector(".cart-count-bubble");
        if (!variantInput || !btn) return;

        // Check for MasterOOS tag - prevent add to cart
        const MasterOOS = window.ProductMeta?.tags?.includes("MasterOOS");
        if (MasterOOS) return;

        const qtyToAdd = parseInt(form.querySelector("input[name='quantity']")?.value || "1");
        try {
          const cartRes  = await fetch("/cart.js");
          const cartData = await cartRes.json();
          const totalQty = cartData.items.reduce((sum,i) => sum + i.quantity, 0);
          if (totalQty + qtyToAdd > 4) {
            showCartLimitModal();
            return;
          }
        } catch {
          alert("Unable to validate cart total. Try again.");
          return;
        }

        btn.classList.add('loading');
        btn.setAttribute('aria-disabled','true');
        try {
          const body = new FormData();
          body.append("id", variantInput.value);
          body.append("quantity", qtyToAdd);
          if (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value) {
            body.append("selling_plan", sellingPlanInput.value);
          }
          await fetch("/cart/add.js", { method: "POST", body, headers:{Accept:"application/json"} });
          await Promise.all([
            refreshCartDrawer(),
            refreshCartCount(cartCountBubble)
          ]);
          enforceCartLimitOnPDP();
        } catch {
          showCartLimitModal();
        } finally {
          // restore the full HTML (with price container) instead of textContent
          btn.disabled = false;
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
          btn.innerHTML = originalButtonHTML;
        }
      }

      // 6) Initialize the Subscribe & Save dropdown
      function initFrequencyButtons() {
  const btnGroup     = document.getElementById("frequencyButtons");
  const buttons      = btnGroup ? btnGroup.querySelectorAll(".freq-btn") : null;
  const hiddenSelect = document.querySelector(".sub-plan-select");
  const priceEl      = document.getElementById("price");
  const oneTimeRadio = document.getElementById("one-time");
  const subRadio     = document.getElementById("sub");
  const targetForm   = document.querySelector('product-form form[action^="/cart/add"]');

  if (!btnGroup || !buttons?.length || !hiddenSelect || !priceEl || !targetForm) {
    console.warn("Frequency buttons: required elements missing");
    return;
  }

  // Ensure hidden selling_plan exists on the real form
  let sellingPlanHidden = targetForm.querySelector("input[name='selling_plan']");
  if (!sellingPlanHidden) {
    sellingPlanHidden = document.createElement("input");
    sellingPlanHidden.type = "hidden";
    sellingPlanHidden.name = "selling_plan";
    sellingPlanHidden.disabled = true;
    targetForm.appendChild(sellingPlanHidden);
  }

  let lastSelectedPlanId = purchaseState.planId || hiddenSelect.value || "";

  // Restore persisted purchase mode after AJAX section swaps.
  if (purchaseState.mode === "sub" && subRadio) {
    subRadio.checked = true;
    if (oneTimeRadio) oneTimeRadio.checked = false;
  } else if (oneTimeRadio) {
    oneTimeRadio.checked = true;
    if (subRadio) subRadio.checked = false;
  }

  const formatPrice = (priceStr) =>
    priceStr.replace(/(\.\d*?[1-9])0+$|\.(?:0)+$/, "$1");

  function setAtcPriceDisplay(displayPrice, displayCompare) {
    const atcEl = document.getElementById("atc_price");
    const cmpEl = document.getElementById("atc_compare_price");
    if (atcEl) atcEl.textContent = displayPrice ? ` - ${displayPrice}` : "";
    if (cmpEl) {
      if (displayCompare && displayCompare !== displayPrice) {
        cmpEl.textContent = displayCompare;
        cmpEl.style.display = "inline";
      } else {
        cmpEl.textContent = "";
        cmpEl.style.display = "none";
      }
    }
  }

  function activateButton(btn) {
    buttons.forEach(b => b.classList.remove("is-active"));
    btn.classList.add("is-active");
  }

  function selectPlanByButton(btn) {
    const planId   = btn.dataset.planId;
    const p        = btn.dataset.price;        // e.g. "$54.00"
    const c        = btn.dataset.comparePrice; // e.g. "$60.00"
    const dispP    = formatPrice(p || "");
    const dispC    = c ? formatPrice(c) : "";

    // UI updates
    priceEl.textContent = dispP;
    setAtcPriceDisplay(dispP, dispC);
    activateButton(btn);

    // Selling plan to form
    hiddenSelect.value = planId;
    sellingPlanHidden.value = planId;
    sellingPlanHidden.disabled = false;

    // for your other listeners
    hiddenSelect.dispatchEvent(new Event("change"));

    lastSelectedPlanId = planId;
    purchaseState.planId = planId;
  }

 function updateForPurchaseOption() {
  const oneBox = oneTimeRadio?.closest(".rc-option");
  const subBox = subRadio?.closest(".rc-option");
  const btnGroup = document.getElementById("frequencyButtons");
  const benefits = document.querySelector(".subscribe-benefits");

  if (subRadio?.checked) {
    purchaseState.mode = "sub";
    oneBox?.classList.remove("rc-option--active");
    subBox?.classList.add("rc-option--active");
    sellingPlanHidden.disabled = false;
    benefits?.classList.add("active");

    // show frequency buttons
    if (btnGroup) btnGroup.style.display = "flex";

    // re-select last chosen plan (or first)
    const targetBtn =
      (lastSelectedPlanId &&
        btnGroup.querySelector(`.freq-btn[data-plan-id="${lastSelectedPlanId}"]`)) ||
      btnGroup.querySelector(".freq-btn");
    if (targetBtn) selectPlanByButton(targetBtn);

  } else {
    purchaseState.mode = "one";
    oneBox?.classList.add("rc-option--active");
    subBox?.classList.remove("rc-option--active");
    sellingPlanHidden.disabled = true;
    benefits?.classList.remove("active");

    // hide frequency buttons
    if (btnGroup) btnGroup.style.display = "none";

    // ATC price = one-time price
    const onePrice = oneTimeRadio?.dataset.oneTimePrice || "";
    setAtcPriceDisplay(formatPrice(onePrice), "");
  }
}


  // Click to toggle radios when user clicks the card
  document.querySelectorAll(".rc-option").forEach(o => {
    o.addEventListener("click", () => {
      const r = o.querySelector('input[type="radio"]');
      if (r) { r.checked = true; r.dispatchEvent(new Event("change", { bubbles:true })); }
    });
  });

  // Button clicks
  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      // Make sure Subscribe is active if they click a frequency
      if (subRadio && !subRadio.checked) {
        subRadio.checked = true;
        subRadio.dispatchEvent(new Event("change", { bubbles: true }));
      }
      selectPlanByButton(btn);
      // lil’ badge pop you had
      const badge = document.getElementById("saveBadge");
      if (badge) {
        badge.classList.remove("pop-badge");
        void badge.offsetWidth;
        badge.classList.add("pop-badge");
      }
    });
  });

  // Radio changes (One-time vs Subscribe)
  oneTimeRadio?.addEventListener("change", updateForPurchaseOption);
  subRadio?.addEventListener("change", updateForPurchaseOption);

  // Initial state
  updateForPurchaseOption();

  // Always seed the visible Subscribe & Save price on load so it shows
  // even when One-time is the default selected option.
  const getPreferredSubButton = () => {
    if (lastSelectedPlanId) {
      const savedBtn = btnGroup.querySelector(`.freq-btn[data-plan-id="${lastSelectedPlanId}"]`);
      if (savedBtn) return savedBtn;
    }
    let btn30 = Array.from(buttons).find(b => b.textContent.includes("Delivery every 30 days"));
    if (!btn30) btn30 = buttons[0];
    return btn30 || null;
  };

  const preferredSubBtn = getPreferredSubButton();
  if (preferredSubBtn && !priceEl.textContent.trim()) {
    priceEl.textContent = formatPrice(preferredSubBtn.dataset.price || "");
  }

  // Prefer “Delivery every 30 days” on load if sub is selected
  if (subRadio?.checked) {
    if (preferredSubBtn) selectPlanByButton(preferredSubBtn);
  }

  // Sold out state (mirrors your previous behavior)
  const isOOS            = window.ProductMeta?.tags?.includes("OOS");
  const MasterOOS        = window.ProductMeta?.tags?.includes("MasterOOS");
  const inventoryQty     = window.ProductMeta?.inventory ?? 9999;
  const baseSoldOut      = window.ProductMeta?.policy === "false";

  function applySoldOutToButtons() {
    buttons.forEach(b => b.disabled = true);
    const atcButton = targetForm.querySelector('[type="submit"]');
    if (atcButton) {
      atcButton.textContent = "Sold Out";
      atcButton.disabled = true;
      atcButton.classList.add("disabled", "sold-out");
    }
    document.querySelectorAll(".rc-option").forEach(option => {
      option.classList.add("sold-out");
      const label = option.querySelector(".rc-option__text");
      if (label && !label.textContent.includes("Sold out")) {
        label.textContent += " – Sold out";
      }
    });
  }

  if ((isOOS && inventoryQty < 100) || baseSoldOut || MasterOOS) {
    applySoldOutToButtons();
  }

  // Hijack submit (keeps your existing handleAddToCart flow)
  targetForm.addEventListener("submit", e => {
    e.preventDefault();
    e.stopImmediatePropagation();
    handleAddToCart(targetForm);
  });
}

      function initBuyerConsentToggle() {
        const buyerConsent = document.querySelector('#shopify-buyer-consent');
        const oneTimeRadio = document.getElementById('one-time');
        const subRadio     = document.getElementById('sub');

        if (!buyerConsent || !oneTimeRadio || !subRadio) return;

        function toggleConsent() {
          if (subRadio.checked) {
            buyerConsent.classList.remove('hidden-consent');
          } else {
            buyerConsent.classList.add('hidden-consent');
          }
        }

        oneTimeRadio.addEventListener('change', toggleConsent);
        subRadio.addEventListener('change', toggleConsent);

        // Initialize on load
        toggleConsent();
      }
     // ── NEW HELPER: pull the visible price into the ATC button ──────────────
      function setAtcPriceFromPriceEl() {
        const atcEl   = document.getElementById("atc_price");
        const oneTimeRadio = document.getElementById("one-time");
        const subRadio     = document.getElementById("sub");
        const subPriceEl   = document.getElementById("price");
        if (atcEl) {
          const oneTimePrice = oneTimeRadio?.dataset.oneTimePrice || "";
          const subPrice = subPriceEl?.textContent.trim() || "";
          const nextPrice = subRadio?.checked ? subPrice : oneTimePrice;
          atcEl.textContent = nextPrice ? ` - ${nextPrice}` : "";
        }
      }
      // 7) Single DOMContentLoaded for drawer + sub-benefits
      
        initBuyerConsentToggle();
        setAtcPriceFromPriceEl();
        disableCartDrawerPlusButtons();
        
        // subscribe-benefits toggle
        const oneTimeRadio = document.getElementById("one-time");
        const subRadio     = document.getElementById("sub");
        const benefits     = document.querySelector(".subscribe-benefits");
        function updateBenefits() {
          if (subRadio.checked) benefits.classList.add("active");
          else                  benefits.classList.remove("active");
        }
        if (oneTimeRadio && subRadio && benefits) {
          oneTimeRadio.addEventListener("change", updateBenefits);
          subRadio.addEventListener("change", updateBenefits);
          updateBenefits();
        }
      

      // 8) Watch for product-form and wire up everything
      const observer = new MutationObserver((_, obs) => {
        const form = document.querySelector("product-form form[action='/cart/add']");
        if (!form) return;
        obs.disconnect();
        initFrequencyButtons();
        setAtcPriceFromPriceEl();
        form.addEventListener("submit", e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          handleAddToCart(form);
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
      enforceCartLimitOnPDP();
  
};

// run once on first page load
document.addEventListener('DOMContentLoaded', window.initAlternateSection);